module.exports = __webpack_public_path__ + "img/superhero.4414a417.png";